
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DevApplication } from '~/interfaces/user.interface';
import Field from '~/components/Field.vue';

@Component({ components: {
    Field
}})
export default class DevApps extends Vue {
    @Prop({}) readonly apps?: DevApplication[] ;

    getChipsColor (scope : string) : string {
        if (scope.indexOf('read') != -1) {
            return 'blue';
        } else if (scope.indexOf('write') != -1) {
            return 'orange';
        } else if (scope.indexOf('access') != -1) {
            return 'red';
        } else {
            return 'blue';
        }
    }
}
